export default __webpack_public_path__ + "static/media/audio.c0f20e0b.svg";